import { Skeleton } from "@components/ui/skeleton";

interface LoadingContentProps {
  title?: string;
  variant?: "spinner" | "skeleton";
  rows?: number;
}

export default function LoadingContent({
  title,
  variant = "spinner",
  rows = 5,
}: LoadingContentProps) {
  if (variant === "skeleton") {
    return (
      <div className="flex flex-col gap-3 p-4 w-full">
        <Skeleton className="h-8 w-48 mb-2" />
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full bg-background">
      <div className="p-8 flex flex-col items-center max-w-sm w-full">
        <div className="mb-4 rounded-full bg-primary/10 p-3 flex items-center justify-center">
          <svg
            width={32}
            height={32}
            fill="none"
            viewBox="0 0 24 24"
            className="animate-spin text-primary"
          >
            <path
              d="M22 12a10 10 0 1 1-10-10"
              stroke="#135045"
              strokeWidth={4}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-primary mb-2 text-center">
          {title ?? "Carregando..."}
        </h2>
      </div>
    </div>
  );
}
